var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"responsive",rawName:"v-responsive.sm.xs",modifiers:{"sm":true,"xs":true}}]},[_c('mobileNav')],1),_vm._v(" "),_c('div',{directives:[{name:"responsive",rawName:"v-responsive.lg.xl.md",modifiers:{"lg":true,"xl":true,"md":true}}]},[_c('sidebar')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c194751","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DashboardNav.vue
// module id = null
// module chunks = 